"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importStar(require("styled-components"));
var utils_1 = require("../../../utils/utils");
var StyledSvg = (0, styled_components_1.default)("svg")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .progress_ring__top {\n    stroke: ", ";\n  }\n\n  .progress_ring__bottom {\n    stroke: ", ";\n  }\n"], ["\n  .progress_ring__top {\n    stroke: ", ";\n  }\n\n  .progress_ring__bottom {\n    stroke: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.dm__primaryColor, theme.primaryColor, "#F47820");
}, function (_a) {
    var theme = _a.theme;
    return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.white, theme.gray4);
});
var ProgressRing = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b, _c = _a.strokeWidth, strokeWidth = _c === void 0 ? 2 : _c, _d = _a.percentage, percentage = _d === void 0 ? 50 : _d, _e = _a.className, className = _e === void 0 ? "" : _e;
    var viewBox = "0 0 ".concat(size, " ").concat(size);
    var radius = (size - strokeWidth) / 2;
    var circumference = radius * Math.PI * 2;
    var dash = (percentage * circumference) / 100;
    return ((0, jsx_runtime_1.jsxs)(StyledSvg, __assign({ className: "wellms-component progress-ring ".concat(className), width: size, height: size, viewBox: viewBox }, { children: [(0, jsx_runtime_1.jsx)("circle", { className: "progress_ring__bottom", fill: "none", stroke: "#F2F2F2", cx: size / 2, cy: size / 2, r: radius, strokeWidth: "".concat(strokeWidth, "px") }), (0, jsx_runtime_1.jsx)("circle", { className: "progress_ring__top", fill: "none", cx: size / 2, cy: size / 2, r: radius, strokeWidth: "".concat(strokeWidth, "px"), transform: "rotate(-90 ".concat(size / 2, " ").concat(size / 2, ")"), strokeDasharray: [dash, circumference - dash].join(" "), strokeLinecap: "round", style: { transition: "all 0.5s" } })] })));
};
exports.default = (0, styled_components_1.withTheme)((0, styled_components_1.default)(ProgressRing)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""]))));
var templateObject_1, templateObject_2;
